// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__1LKUE","online":"styles_online__2o7dF","offline":"styles_offline__10E5X","booted":"styles_booted__3mnIO"};